import {ShowAuthorOption} from "./ShowAuthorOption";
import {ShowHiddenColumnsOption} from "./ShowHiddenColumnsOption";
import {ShowOtherUsersNotesOption} from "./ShowOtherUsersNotesOption";
import {ShowAllBoardSettings} from "./ShowAllBoardSettings";
import {LockBoard} from "./LockBoard";

export const BoardOption = {
  ShowAuthorOption,
  ShowHiddenColumnsOption,
  ShowOtherUsersNotesOption,
  ShowAllBoardSettings,
  LockBoard,
};
